module.exports = __webpack_public_path__ + "40fe17d341092477b4f020d252e5e99b.MP3";